export default __webpack_public_path__ + "static/media/foto.9aa91a08.png";